import { t } from '../services/configService';
import { stripTags } from './stringUtils';

const getEntityMediaImageAlt = entity =>
  entity.mediaImage.alt &&
  !entity.mediaImage.alt.startsWith('http') &&
  entity.mediaImage.alt.indexOf('.jpg') === -1
    ? entity.mediaImage.alt
    : null;

const getEntityMediaImageTitle = entity =>
  entity.mediaImage.title &&
  !entity.mediaImage.title.startsWith('http') &&
  entity.mediaImage.title.indexOf('.jpg') === -1
    ? entity.mediaImage.title
    : null;

export const getImageEntityAlt = entity =>
  getEntityMediaImageAlt(entity) ||
  stripTags(entity.caption) ||
  getEntityMediaImageTitle(entity);

export const getImageEntityTitle = entity =>
  getEntityMediaImageTitle(entity) ||
  getEntityMediaImageAlt(entity) ||
  stripTags(entity.caption);

const creditPrefixes = {
  'illustrated-by': {
    single: '__ILLUSTRATED_BY__',
    plural: '__ILLUSTRATIONS_BY__'
  },
  'photograph-by': { single: '__PHOTOGRAPH_BY__', plural: '__PHOTOGRAPHS_BY__' }
};

export const getImageCreditPrefix = (prefix, plural = false) =>
  plural
    ? t(creditPrefixes[prefix]?.plural) ||
      t(creditPrefixes['photograph-by'].plural)
    : t(creditPrefixes[prefix]?.single) ||
      t(creditPrefixes['photograph-by'].single);
